module.exports = __webpack_public_path__ + "img/bg-what-we-do-2.b9df4801.jpg";